import type { AuthConfig, FirebaseConfig } from "@kiddocare-platform/portal-common/helpers";

class ConfigHelper {

  public GetApiCoreUrl(): string {
    return import.meta.env.VITE_API_CORE_URL || 'no_api_url';
  }

  public GetAppEnv(): string {
    return import.meta.env.VITE_ENV || 'no_env';
  }

  public GetAppVersion(): string {
    return import.meta.env.VITE_VERSION || 'no_version';
  }

  public GetAuthConfig(): AuthConfig {
    return {
      authority: import.meta.env.VITE_AUTH_AUTHORITY || 'no_auth_url',
      clientId: import.meta.env.VITE_AUTH_CLIENT_ID || 'no_client_id',
      clientSecret: import.meta.env.VITE_AUTH_CLIENT_SECRET || 'no_client_secret',
      redirectUri: import.meta.env.VITE_AUTH_REDIRECT_URI || 'no_redirect_uri',
      postLogoutRedirectUri: import.meta.env.VITE_AUTH_POST_LOGOUT_REDIRECT_URI || 'no_post_logout_redirect_uri',
      scope: import.meta.env.VITE_AUTH_SCOPE || 'no_scope',
      responseType: import.meta.env.VITE_AUTH_RESPONSE_TYPE || 'no_response_type',
      prefix: import.meta.env.VITE_AUTH_PREFIX || 'no_prefix',
      minutesOfInactivity: import.meta.env.VITE_AUTH_MINUTES_OF_INACTIVITY ? parseInt(import.meta.env.VITE_AUTH_MINUTES_OF_INACTIVITY ) : 30,
    };
  }

  public GetFirebaseConfig(): FirebaseConfig {
    return {
      vapidKey: import.meta.env.VITE_FIREBASE_VAPID_KEY || 'no_vapid_key',
      config:
      {
        apiKey: import.meta.env.VITE_FIREBASE_API_KEY || "none",
        authDomain: import.meta.env.VITE_FIREBASE_AUTH_DOMAIN || "none",
        projectId: import.meta.env.VITE_FIREBASE_PROJECT_ID || "none",
        storageBucket: import.meta.env.VITE_FIREBASE_STORAGE_BUCKET || "none",
        messagingSenderId: import.meta.env.VITE_FIREBASE_MESSAGING_SENDER_ID || "none",
        appId: import.meta.env.VITE_FIREBASE_APP_ID || "none",
        measurementId: import.meta.env.VITE_FIREBASE_MEASUREMENT_ID || "none"
      }
    };
  }
  
  public GetStripePublishableKey(): string {
    return import.meta.env.VITE_STRIPE_PUBLISHABLE_KEY || 'no_stripe_publishable_key';
  }

  public GetAgoraAppId(): string {
    return import.meta.env.VITE_AGORA_APP_ID || 'no_agora_app_id';
  }
}

const configHelper = new ConfigHelper();
export { configHelper as ConfigHelper };